import React from "react";
import Carousel1 from "../assets/carousel-1.jpeg";
import Carousel2 from "../assets/carousel-2.jpeg";
import Carousel3 from "../assets/carousel-3.jpeg";
import Carousel4 from "../assets/carousel-4.jpeg";
import Carousel5 from "../assets/carousel-5.jpeg";

const CarouselData = [Carousel1, Carousel2, Carousel3, Carousel4, Carousel5];
const Carousel = () => {
  return (
    <section>
      <article>
        <div>
          <ul>
            {CarouselData.map((item) => {
              return (
                <li>
                  <img
                    src={item}
                    style={{
                      width: "20rem",
                      objectFit: "cover",
                      height: "15rem",
                      aspectRatio: 4 / 3,
                      borderRadius: "0.75rem",
                    }}
                    alt=""
                  />
                </li>
              );
            })}
          </ul>
        </div>
        <div>
          <ul>
            {CarouselData.map((item) => {
              return (
                <li>
                  <img
                    src={item}
                    style={{
                      width: "20rem",
                      objectFit: "cover",
                      height: "15rem",
                      aspectRatio: 4 / 3,
                      borderRadius: "0.75rem",
                    }}
                    alt=""
                  />
                </li>
              );
            })}
          </ul>
        </div>
      </article>
    </section>
  );
};

export default Carousel;
